import { Container, Grid } from '@material-ui/core'
import React, { useState } from 'react'
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout'
import { Field, Form, FormElement } from '@progress/kendo-react-form'
import TextAreaWrapper from '../../onboarding/steps/inputs/textareaWrapper'
import InputPureWrapper from '../../onboarding/steps/inputs/inputPureWrapper'
import { ButtonHLPure, InputHLPure } from '../../../pures'
import { DropDownList } from '@progress/kendo-react-dropdowns'
import LabelPure from '../../../pures/label/label.pure'
import { RadioGroup } from '@progress/kendo-react-inputs'
import { useTranslation } from 'react-i18next'
import NumericTextboxWrapper from '../components/numeric-textbox-wrapper'
import { requiredValidator } from '../components/validator'
import { Checkbox } from '@progress/kendo-react-inputs'

const AdditionalFieldField = (props) => {
    const {
        value,
        onChange
    } = props

    const { t } = useTranslation('chatbot', { keyPrefix: 'conversationsConfig.conversations' })

    const types = [
        { label: t("botNode.customInputTypes.fileupload"), value: 'fileupload' },
        { label: t("botNode.customInputTypes.filedownload"), value: 'filedownload' },
        { label: t("botNode.customInputTypes.combobox"), value: 'combobox' }
    ]
    const comboboxTypes = [
        { label: t("botNode.comboboxTypes.static"), value: 'static' },
        { label: t("botNode.comboboxTypes.dynamic"), value: 'dynamic' }
    ]

    const handleChange = (field, fieldValue) => {
        const prevValue = { ...value }

        if (field === 'type') {
            if (fieldValue !== prevValue.type) {
                onChange({ value: { type: fieldValue } })
                return;
            }
        }

        if (prevValue.type === 'combobox' && field === 'comboboxType' && prevValue.comboboxType !== fieldValue) {
            onChange({ value: { type: 'combobox', comboboxType: fieldValue } })
            return;
        }

        onChange({ value: { ...prevValue, [field]: fieldValue } })
    }

    return (
        <>
            <Grid item xs={12}>
                <LabelPure title={t("botNode.customInput")} />
                <DropDownList
                    data={types}
                    value={types.find(t => t.value === value?.type)}
                    dataItemKey="value"
                    textField="label"
                    onChange={(e) => handleChange('type', e.value.value)}
                    className="eticket-dropdown-field"
                    style={{ margin: 0 }}
                />
                <p className='hint'>{t("botNode.customInputHint")}</p>
            </Grid>
            {
                value?.type === 'fileupload' &&
                <InputHLPure
                    labelInput={t("botNode.extensions")}
                    valueInput={value?.extensions}
                    handleChangeInput={(e) => handleChange('extensions', e.target.value)}
                />
            }
            {
                value?.type === 'filedownload' &&
                <InputHLPure
                    labelInput={t("botNode.filedownloadFunction")}
                    valueInput={value?.function}
                    handleChangeInput={(e) => handleChange('function', e.target.value)}
                />
            }
            {
                value?.type === 'combobox' &&
                <>
                    <Grid item xs={12}>
                        <RadioGroup
                            data={comboboxTypes}
                            value={value?.comboboxType}
                            onChange={(e) => handleChange('comboboxType', e.value)}
                        />
                    </Grid>
                    {
                        value?.comboboxType === 'static' &&
                        <InputHLPure
                            labelInput={t("botNode.comboboxOptions")}
                            valueInput={value?.options}
                            handleChangeInput={(e) => handleChange('options', e.target.value)}
                        />
                    }
                    {
                        value?.comboboxType === 'dynamic' &&
                        <InputHLPure
                            labelInput={t("botNode.comboboxFunction")}
                            valueInput={value?.function}
                            handleChangeInput={(e) => handleChange('function', e.target.value)}
                        />
                    }
                </>
            }
        </>
    )
}

const BotNodeDetails = (props) => {
    const { node, onSaveNode } = props
    const { t } = useTranslation('chatbot', { keyPrefix: 'conversationsConfig.conversations' })
    const { t: tCommon } = useTranslation('common')

    const [data, setData] = useState(node.data)
    const [formKey, setFormKey] = useState(1)
    const resetForm = () => setFormKey(formKey + 1)

    const onSubmit = async (formData) => {
        await onSaveNode(formData)
        setData(prev => ({ ...prev, ...formData }))
        resetForm()
    }

    return (
        <Container disableGutters >
            <Form
                key={`botnode-${formKey}`}
                initialValues={data}
                onSubmit={onSubmit}
                render={(formRenderProps) => {
                    const isIaChecked = formRenderProps.valueGetter('ia') || false;
                    return (
                        <FormElement>
                            <Grid container spacing={2} className='conversation-node-form bot-node-form'>
                                <Grid item xs={12}>
                                    <h3>{t("botNode.title")}</h3>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        id="botMessage"
                                        name={'botMessage'}
                                        component={TextAreaWrapper}
                                        label={t("botNode.botMessage")}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PanelBar>
                                        <PanelBarItem title={t("advancedSettings")}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12}>
                                                    <Field
                                                        id='ia'
                                                        name={'ia'}
                                                        component={Checkbox}
                                                        label={t('ia')}
                                                    />
                                                </Grid>
                                                {isIaChecked && (
                                                    <Grid item xs={12}>
                                                        <Field
                                                            id='maxQuantityMessages'
                                                            name={'maxQuantityMessages'}
                                                            component={NumericTextboxWrapper}
                                                            label={t('maxQuantityMessages')}
                                                            validator={requiredValidator}
                                                        />
                                                    </Grid>
                                                )}
                                                <Grid item xs={12}>
                                                    <Field
                                                        id="functionName"
                                                        name={'functionName'}
                                                        component={InputPureWrapper}
                                                        label={t("botNode.functionName")}
                                                    />
                                                    <p className='hint'>{t("botNode.functionNameHint")}</p>
                                                </Grid>
                                                <Field
                                                    id="customInput"
                                                    name={'customInput'}
                                                    component={AdditionalFieldField}
                                                />
                                            </Grid>

                                        </PanelBarItem>
                                    </PanelBar>
                                </Grid>

                                <Grid item xs={12} className='button-actions'>
                                    {
                                        formRenderProps.modified &&
                                        <>
                                            <ButtonHLPure
                                                colorScheme="error"
                                                outlined nameBtn={tCommon("cancel")}
                                                onClick={resetForm}
                                                disabled={formRenderProps.submitted}
                                            />
                                            <ButtonHLPure
                                                primary
                                                nameBtn={tCommon("save")}
                                                type="submit"
                                                disabled={formRenderProps.submitted}
                                            />
                                        </>
                                    }
                                </Grid>
                            </Grid>
                        </FormElement>
                    )
                }}
            />
        </Container>
    )
}

export default BotNodeDetails